import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import { createdUpdatedInfo, notify, validateEmail } from '../../../utils';
import ActionIcon from '../../../components/custom/ActionIcon';
import { CronJob } from '../../../globals/interfaces';
import { FormGroup } from 'reactstrap';
import { Input } from 'reactstrap';
import Icon from '../../../components/custom/Icon';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    selectedJob: CronJob | undefined;
    addEmail: (email: string) => Promise<void>;
}

export default function ModalAddEmail ({
    modal,
    setModal,
    selectedJob,
    addEmail
}: Props) {

    const [email, setEmail] = useState('');
    const validEmail = validateEmail(email);

    const handleAddEmail = async () => {
        await addEmail(email);
        notify('Email added');
        setModal(false);
    }

    const toggle = () => setModal(!modal);

    useEffect(() => {
        setEmail('');
    }, [modal]);

    if (!selectedJob) {
        return null;
    }

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Add Email for {selectedJob.displayName}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <FlexContainer>
                    <Input value={email} onChange={e => setEmail(e.target.value)} />
                    <Icon className={validEmail ? 'fas fa-duotone fa-solid fa-circle-check text-success' : 'fas fa-duotone fa-solid fa-triangle-exclamation text-danger'} size={30} />
                </FlexContainer>
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <Label>
                        {createdUpdatedInfo({selectedJob})}
                    </Label>
                    <FooterButtonsContainer>
                        <ActionIcon 
                            type={'save'} 
                            onClick={handleAddEmail}
                            disabled={!validEmail} 
                            simulateLoading={true}
                        />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;

const FlexContainer = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;

    input {
        width: 75%;
    }
`;